// Generated by purs version 0.15.15
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var StatusCode = function (x) {
    return x;
};
var showStatusCode = {
    show: function (v) {
        return "(StatusCode " + (show(v) + ")");
    }
};
var newtypeStatusCode = {
    Coercible0: function () {
        return undefined;
    }
};
var eqStatusCode = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordStatusCode = {
    compare: function (x) {
        return function (y) {
            return compare(x)(y);
        };
    },
    Eq0: function () {
        return eqStatusCode;
    }
};
export {
    StatusCode,
    eqStatusCode,
    ordStatusCode,
    newtypeStatusCode,
    showStatusCode
};
//# sourceMappingURL=index.js.map
